import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=3d08615f&scoped=true&"
import script from "./FooterBar.vue?vue&type=script&lang=ts&"
export * from "./FooterBar.vue?vue&type=script&lang=ts&"
import style0 from "./FooterBar.vue?vue&type=style&index=0&id=3d08615f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d08615f",
  null
  
)

export default component.exports